import React from 'react'
import { CONSTANTS, colors } from 'constants/index'
import { FormikInput, FormikSelect, FormikAutocomplete } from 'components'
import { makeStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
import { useFormikContext } from 'formik'

const useStyles = makeStyles({
  twoColumn: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  inputContainer: {
    width: 'calc(50% - 13px)',
  },
  phoneInput: {
    height: '40px !important',
  },
  selectIcon: {
    marginRight: '7px',
  },
  contactInfo: {
    padding: 24,
    border: `1px solid ${colors.BASIC.COLOR[5]}`,
    borderRadius: 4,
    backgroundColor: colors.WHITE,
  },
  '@media(max-width:939px)': {
    twoColumn: {
      flexDirection: 'column',
    },
    inputContainer: {
      width: '100%',
      maxWidth: 372,
    },
  },
  formikResponsive: {
    marginBottom: 10,
  },
})

const ClientContactInfoFormBody = ({ states, provinces, countries, updateContactInfo, disableContactInfoStyle }) => {
  const classes = useStyles()
  const { values, setFieldValue } = useFormikContext()

  const getLocationOptions = () => {
    const selectedCountry = values.country
    if (selectedCountry === 124) return provinces
    return states
  }

  const handleCountryChange = event => {
    updateContactInfo(event)
    setFieldValue('state', '')
    updateContactInfo({ target: { name: 'state', value: '' } })
  }

  return (
    <div className={classNames({ [classes.contactInfo]: !disableContactInfoStyle })}>
      <div className={classes.inputContainer}>
        <FormikSelect
          variant="outlined"
          size="small"
          name="country"
          label="Country"
          type="text"
          fullWidth
          options={countries}
          handleChange={handleCountryChange}
          containerClasses={classes.formikResponsive}
        />
      </div>
      <div className={classes.twoColumn}>
        <FormikInput
          variant="outlined"
          size="small"
          name="street"
          label="Address"
          type="text"
          fullWidth
          containerClasses={classes.inputContainer}
          handleChange={updateContactInfo}
        />
        <FormikInput
          variant="outlined"
          size="small"
          name="suite"
          required={false}
          label="Apartment, Suite, PO Box"
          type="text"
          fullWidth
          containerClasses={classes.inputContainer}
          handleChange={updateContactInfo}
        />
      </div>
      <div className={classes.twoColumn}>
        <FormikInput
          variant="outlined"
          size="small"
          name="city"
          label="City"
          type="text"
          fullWidth
          containerClasses={classes.inputContainer}
          handleChange={updateContactInfo}
        />
        <FormikAutocomplete
          key={`state-field-${values.country || 'default'}`}
          variant="outlined"
          size="small"
          name="state"
          label="State / Province"
          type="text"
          fullWidth
          containerClasses={classes.inputContainer}
          options={getLocationOptions()}
          handleChange={updateContactInfo}
          filterOptions={(options, { inputValue }) =>
            getLocationOptions().filter(option => option.label.toLowerCase().startsWith(inputValue.toLowerCase()))
          }
        />
      </div>
      <div className={classes.twoColumn}>
        <FormikInput
          variant="outlined"
          size="small"
          name="zip"
          label="Zip Code / Postal Code"
          type="text"
          fullWidth
          containerClasses={classes.inputContainer}
          handleChange={updateContactInfo}
        />
        <FormikInput
          key={`phone-${values.country || 'default'}`}
          variant="outlined"
          size="small"
          name="phone"
          label="Mobile phone"
          type={CONSTANTS.INPUT_TYPE.PHONE}
          fullWidth
          containerClasses={classes.inputContainer}
          inputClass={classes.phoneInput}
          country={values.country === 124 ? 'ca' : 'us'}
          handleChange={updateContactInfo}
        />
      </div>
    </div>
  )
}

export default ClientContactInfoFormBody
